import type { ModuleId } from '../../core/types';
import type { AnyRuntimeTrainingModule } from '../runtime';
import { centralPeripheralModule } from './central-peripheral';
import { movingTargetModule } from './moving-target';
import { playerTrackModule } from './player-track';
import { readSwitchModule } from './read-switch';

export const TRAINING_MODULES: readonly AnyRuntimeTrainingModule[] = [
  readSwitchModule,
  centralPeripheralModule,
  playerTrackModule,
  movingTargetModule,
];

const moduleById = new Map<ModuleId, AnyRuntimeTrainingModule>(
  TRAINING_MODULES.map((module) => [module.id, module]),
);

export function getTrainingModule(moduleId: ModuleId): AnyRuntimeTrainingModule {
  const module = moduleById.get(moduleId);
  if (!module) throw new Error(`Unknown training module: ${moduleId}`);
  return module;
}

export * from './central-peripheral';
export * from './moving-target';
export * from './player-track';
export * from './read-switch';

